/**
 * Best supplements lead magnet: dual forms -> Mailchimp tag via globalAddTags, optional Shopify customer, thank-you overlay.
 * Prefill email: emailMailchimp, then customerEmail (never overwrites non-empty fields). On submit, form values are written to storage before globalAddTags / globalAddMailchimpParam.
 */
(function () {
  const TAG = 'lead_magnet_best_supplement_for_each_metric';
  const STORAGE_FNAME = 'bs_metric_fname';
  const LS_EMAIL_MAILCHIMP = 'emailMailchimp';
  const LS_EMAIL_CUSTOMER = 'customerEmail';
  const LS_FIRST_NAME = 'first_name';

  function isValidEmail(email) {
    return typeof email === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  }

  function showFormError(form, message) {
    var el = form.querySelector('[data-bs-metric-error]');
    if (!el) return;
    el.textContent = message;
    el.setAttribute('data-visible', 'true');
  }

  function clearFormError(form) {
    var el = form.querySelector('[data-bs-metric-error]');
    if (!el) return;
    el.textContent = '';
    el.setAttribute('data-visible', 'false');
  }

  async function createCustomerInShopify(customerEmail) {
    try {
      var response = await fetch(
        'https://us-central1-nutricodeapp-3da5f.cloudfunctions.net/SHOPIFY_createCustomer/' +
          encodeURIComponent(customerEmail)
      );
      if (!response.ok) throw new Error('Customer creation failed');
      return await response.json();
    } catch (e) {
      console.error('createCustomerInShopify failed', e);
      return null;
    }
  }

  function openThankYouOverlay() {
    var root = document.getElementById('bs-metric-thankyou-root');
    if (!root) return;
    if (document.body.classList.contains('bs-metric-thankyou-open')) return;

    if (typeof trackMeta === 'function') {
      trackMeta('leadMagnetBestSupplements');
    }
    if (typeof trackGoogle === 'function') {
      trackGoogle('leadMagnetBestSupplements');
    }

    var backdrop = root.querySelector('.bs-metric-thankyou__backdrop');
    var shell = root.querySelector('.bs-metric-thankyou__shell');
    var homeBtn = document.getElementById('bs-metric-thankyou-home-btn');

    root.removeAttribute('hidden');
    root.setAttribute('aria-hidden', 'false');
    document.body.classList.add('bs-metric-thankyou-open');

    if (backdrop) backdrop.classList.remove('is-open');
    if (shell) shell.classList.remove('is-open');

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (backdrop) backdrop.classList.add('is-open');
        if (shell) shell.classList.add('is-open');
        if (homeBtn) homeBtn.focus();
      });
    });
  }

  function initReveal() {
    if (!window.IntersectionObserver) {
      document.querySelectorAll('.bs-metric-reveal').forEach(function (el) {
        el.classList.add('bs-metric-reveal--visible');
      });
      return;
    }
    var reduce =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      document.querySelectorAll('.bs-metric-reveal').forEach(function (el) {
        el.classList.add('bs-metric-reveal--visible');
      });
      return;
    }
    var obs = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('bs-metric-reveal--visible');
            obs.unobserve(e.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    document.querySelectorAll('.bs-metric-reveal').forEach(function (el) {
      obs.observe(el);
    });
  }

  function initScrollToHeroForm() {
    document
      .querySelectorAll('a.bs-metric__scroll-to-form[href^="#"]')
      .forEach(function (anchor) {
        anchor.addEventListener('click', function (e) {
          var href = anchor.getAttribute('href');
          if (!href || href.length < 2) return;
          var target = document.querySelector(href);
          if (!target) return;
          e.preventDefault();
          var instant =
            window.matchMedia &&
            window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          target.scrollIntoView({
            behavior: instant ? 'auto' : 'smooth',
            block: 'center',
          });
        });
      });
  }

  function getStoredEmail() {
    try {
      var mc = localStorage.getItem(LS_EMAIL_MAILCHIMP);
      if (mc && String(mc).trim()) return String(mc).trim();
      var cust = localStorage.getItem(LS_EMAIL_CUSTOMER);
      if (cust && String(cust).trim()) return String(cust).trim();
    } catch (err) {
      console.warn('getStoredEmail', err);
    }
    return '';
  }

  function getStoredFirstName() {
    try {
      var v = localStorage.getItem(LS_FIRST_NAME);
      if (v && String(v).trim()) return String(v).trim();
    } catch (err) {
      console.warn('getStoredFirstName', err);
    }
    return '';
  }

  function prefillBsMetricForms() {
    var email = getStoredEmail();
    var fname = getStoredFirstName();
    if (!email && !fname) return;
    document.querySelectorAll('form.bs-metric-form').forEach(function (form) {
      var emailInput = form.querySelector('[name="bs_metric_email"]');
      var firstInput = form.querySelector('[name="bs_metric_first_name"]');
      if (emailInput && email && !String(emailInput.value || '').trim()) {
        emailInput.value = email;
      }
      if (firstInput && fname && !String(firstInput.value || '').trim()) {
        firstInput.value = fname;
      }
    });
  }

  function initForms() {
    var forms = document.querySelectorAll('form.bs-metric-form');
    forms.forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearFormError(form);

        var firstInput = form.querySelector('[name="bs_metric_first_name"]');
        var emailInput = form.querySelector('[name="bs_metric_email"]');
        var first =
          firstInput && firstInput.value ? firstInput.value.trim() : '';
        var email = emailInput && emailInput.value ? emailInput.value.trim() : '';

        if (!first) {
          showFormError(form, 'Please enter your first name.');
          return;
        }
        if (!isValidEmail(email)) {
          showFormError(form, 'Please enter a valid email address.');
          return;
        }

        try {
          /* Submitted email wins for downstream workers; emailMailchimp beats customerEmail when reading storage */
          localStorage.setItem(LS_EMAIL_MAILCHIMP, email);
          localStorage.setItem(LS_FIRST_NAME, first);
          sessionStorage.setItem(STORAGE_FNAME, first);
        } catch (err) {
          console.warn('Unable to persist email/first name', err);
        }

        var submitBtn = form.querySelector('[type="submit"]');
        var submitLabelOriginal = submitBtn ? submitBtn.textContent : '';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Submitting...';
        }

        setTimeout(function () {
          openThankYouOverlay();
        }, 2000);

        Promise.resolve()
          .then(function () {
            if (typeof globalAddTags !== 'function') {
              throw new Error('globalAddTags is not available');
            }
            var tagsP = globalAddTags([TAG], email);
            var mergeP =
              typeof globalAddMailchimpParam === 'function'
                ? globalAddMailchimpParam({ FNAME: first }, email)
                : Promise.resolve({ success: true });
            return Promise.allSettled([tagsP, mergeP]);
          })
          .then(function (outcomes) {
            var tagOutcome = outcomes[0];
            var mergeOutcome = outcomes[1];
            var tagRes =
              tagOutcome.status === 'fulfilled' ? tagOutcome.value : null;
            var mergeRes =
              mergeOutcome.status === 'fulfilled' ? mergeOutcome.value : null;

            if (tagOutcome.status === 'rejected') {
              console.error('globalAddTags rejected', tagOutcome.reason);
            }
            if (!tagRes || tagRes.success !== true) {
              throw new Error(
                (tagRes && tagRes.message) || 'Could not apply subscription tag'
              );
            }

            if (mergeOutcome.status === 'rejected') {
              console.warn('globalAddMailchimpParam rejected', mergeOutcome.reason);
            } else if (!mergeRes || mergeRes.success !== true) {
              console.warn('globalAddMailchimpParam:', mergeRes && mergeRes.message);
            }

            return createCustomerInShopify(email);
          })
          .catch(function (err) {
            console.error('Lead magnet submit failed', err);
          })
          .finally(function () {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = submitLabelOriginal;
            }
          });
      });
    });
  }

  function boot() {
    prefillBsMetricForms();
    initForms();
    initReveal();
    initScrollToHeroForm();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
